<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">สรุปยอดเติมเครดิตของแต่ละสาขา</h1>
                    <p class="text-white pb-3 px-3">รายการยอดเติมเครดิตของแต่ละสาขา</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-12">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-4">
                                                <date-range-picker
                                                    class="w-100"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :opens="'center'"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                             <div class="col-lg-2">
                                                <v-select
                                                    :options="listAgent"
                                                    label="name"
                                                    placeholder="เลือกตัวแทนที่ต้องการค้นหา"
                                                    v-model="agentId"
                                                    :reduce="agent => agent.agent_id"
                                                    taggable
                                                >
                                                    <template v-slot:option="option">
                                                        <span>{{ option.dealer_id }} ( {{option.name}} )</span>
                                                    </template>
                                                </v-select>
                                            </div>
                                            <div class="col-lg-2">
                                                <v-select
                                                    :options="listShop"
                                                    label="name"
                                                    placeholder="เลือกสาขาที่ต้องการค้นหา"
                                                    v-model="shopId"
                                                    :reduce="shop => shop.wallet_account_shop.account_id"
                                                    taggable
                                                >
                                                    <template v-slot:option="option">
                                                        <span>{{ option.shop_code }} ( {{option.name}} )</span>
                                                    </template>
                                                </v-select>
                                            </div>
                                            <div class="col-lg-2">
                                                <select class="form-control" v-model="filterChannel">
                                                    <option :value="channel.key" v-for="channel in dataChannel" :key="channel.key">{{channel.title}}</option>
                                                </select>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res"
                                                    @click="historyTopUpWallet()" >
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <b-form-group id="input-group-1" label="ตัวกรอง" label-for="input-1" class="mb-0">
                                        <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                    </b-form-group>
                                </div>
                                 <div class="col-lg-8 col-md-6 d-flex justify-content-end">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel 
                                                :columns="columnsExcel" 
                                                :getData="getDataTopupExportExcel"
                                                name="ประวัติเติมเงินสาขา " 
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                show-empty
                                responsive
                                :items="data"
                                :fields="fields"
                                :filter="filter"
                                :busy="busy"
                                class="scroll-bar-pop"
                                foot-clone
                                >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                                <template slot="created_at" slot-scope="row">{{ row.item.created_at | dateFormat }}</template>
                                <template slot="subject" slot-scope="row">
                                    <span>
                                        {{statusPaymentSubject(row.item.subject).text}}
                                    </span>
                                </template>
                                <template slot="credit" slot-scope="row">
                                    {{ row.item.credit | numFormat('0,0.00') }}
                                </template>
                                <template slot="status" slot-scope="row">
                                    <b-badge :variant="statusPayment(row.item.status).color +' report'" >
                                        {{statusPayment(row.item.status).status}}
                                    </b-badge>
                                </template>
                                <template slot="ref_no2" slot-scope="row">
                                    <span>
                                        {{statusPaymentChannel(row.item.ref_no2).text}}
                                    </span>
                                </template>
                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_created_at">&nbsp;</template>
                                <template slot="FOOT_transaction_id">&nbsp;</template>
                                <template slot="FOOT_shop_code">&nbsp;</template>
                                <template slot="FOOT_shop_name">&nbsp;</template>
                                <template slot="FOOT_shop_owner_name">&nbsp;</template>
                                <template slot="FOOT_subject">&nbsp;</template>
                                <template slot="FOOT_credit">
                                    {{footerTotal.credit | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_status">&nbsp;</template>
                                <template slot="FOOT_ref_no2">&nbsp;</template>
                                <template slot="FOOT_remark">&nbsp;</template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="dataLength"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :value="pagination.currentPage" 
                                    @input="changePage"
                                    align="right" >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { getListShop } from "@/axios/shop.js";
import { getListAgent } from "@/axios/agent.js";
import { statusPaymentSubject , statusPayment , statusPaymentChannel } from "@/axios/walletPayment.js"

export default {
    name: "historytopupwallettoshop",
    components:{
        ExportExcel
    },
    data() {
        return {
            busy: true,
            data: [],
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            filter: null,
            filterChannel: 'DEPOSIT_PGW',
            agentId: null,
            shopId: null,
            listShop: [],
            listAgent: [],
            dataChannel:[
                { key: 'DEPOSIT_PGW' , title: 'เติมเงินโดยร้านค้า' }, 
                { key: 'DEPOSIT_INSTANT' , title: 'เติมเงินโดยผู้ดูแลระบบ' }, 
            ],
            pagination:{
                currentPage: 1,
                perPage: 1,
                totalPage: 1
            },
            statusPaymentSubject: statusPaymentSubject,
            statusPayment: statusPayment,
            statusPaymentChannel: statusPaymentChannel
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        getListShop().then( shop => {
            this.listShop = [ {wallet_account_shop:{account_id: false} , name: 'ดูทั้งหมด'} , ...shop.filter( data => data.wallet_open == true )];
        })
        getListAgent().then( agent => {
            this.listAgent = [ {agent_id: false , name: 'ดูทั้งหมด'} , ...agent.filter( data => data.wallet_open == true )];
        })
        this.historyTopUpWallet()
    },
    methods: {
        logEvent( event , date ){
            if( event == 'startSelection' ){
                this.minDate = moment(date, 'YYYY-MM-DD').add(-1, 'months').format("YYYY-MM-DD")
                this.maxDate =  moment(date, 'YYYY-MM-DD').add(1, 'months').format("YYYY-MM-DD")
                if( moment(date, 'YYYY-MM-DD').add(1, 'months').valueOf() > moment().valueOf() ){
                    this.maxDate = moment().format("YYYY-MM-DD");
                }
            }else if( event == 'finishSelection' ){
                this.minDate = null
                this.maxDate = moment().format("YYYY-MM-DD");
            }
        },
        changePage(i){
            if (this.pagination.currentPage == i) return
            this.pagination.currentPage = i
            this.historyTopUpWallet()
        },
        async historyTopUpWallet(){
            this.busy = true
            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
            await this.$http
                .get(
                    
                    this.$API_URL + "/wallet/report/transactionInfoStatement",{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            date_start: dateStart,
                            date_end: dateEnd,
                            subject: 'deposit',
                            filter: { payment_method: this.filterChannel },
                            ...( this.agentId ) ? { agent_id: this.agentId } : {},
                            ...( this.shopId ) ? { account_id: this.shopId } : {},
                            page: this.pagination.currentPage
                        }
                    }
                )
                .then(res => {
                    let result = res.data
                    if( result.status ){
                        this.data = result.data.data
                        this.pagination.perPage = result.data.per_page
                        this.pagination.currentPage = result.data.page
                        this.pagination.totalPage = result.data.total_page
                    }
                    this.busy = false
                })
        },
        async getDataTopupExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + "/wallet/report/transactionInfoStatement",{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    subject: 'deposit',
                                    filter: { payment_method: this.filterChannel },
                                    ...( this.agentId ) ? { agent_id: this.agentId } : {},
                                    ...( this.shopId ) ? { account_id: this.shopId } : {},
                                    page: page++
                                }
                            }
                        )
                    ) 
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data.data)
                    })
                    resolve(dataExcel)
                })
            })
        },
    },
    computed: {
        dataLength(){
            return Number(this.pagination.totalPage) *  Number(this.pagination.perPage)
        },
        fields(){ 
            let fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true , class:"text-center" },
                { key: "transaction_id", field: "transaction_id", label: "หมายเลขรายการ", sortable: true , class:"text-center" },
                { key: "shop_code", field: "shop_code", label: "รหัสร้าน", sortable: true },
                { key: "shop_name", field: "shop_name", label: "ชื่อร้านค้า", sortable: true },
                { key: "shop_owner_name", field: "shop_owner_name", label: "ชื่อเจ้าของร้าน", sortable: true },
                { key: "subject", field: "subject", label: "ประเภทรายการ", sortable: true },
                { key: "credit", field: "credit", label: "จำนวนเครดิต (บาท)", sortable: true },
                { key: "status", field: "status", label: "สถานะรายการ", sortable: true },
                { key: "ref_no2", field: "ref_no2", label: "ช่องทาง", sortable: true },
                { key: "remark", field: "remark", label: "หมายเหตุ", sortable: true }

            ]
            return fields
        },
        columnsExcel(){
            let columns =  [
                { field: "created_at", label: "วันเวลาที่ทำรายการ"  },
                { field: "transaction_id", label: "หมายเลขรายการ"  },
                { field: "shop_code", label: "รหัสร้าน" },
                { field: "shop_name", label: "ชื่อร้านค้า" },
                { field: "shop_owner_name", label: "ชื่อเจ้าของร้าน" },
                { 
                    field: "subject", 
                    label: "ประเภทรายการ",
                    dataFormat: value => {
                        return statusPaymentSubject( value ).text;
                    }
                },
                { 
                    field: "credit", 
                    label: "จำนวนเครดิต (บาท)",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                },
                { 
                    field: "status",
                    label: "สถานะรายการ",
                    dataFormat: value => {
                        return statusPayment( value ).status;
                    }
                },
                { 
                    field: "ref_no2", 
                    label: "ช่องทาง",
                    dataFormat: value => {
                        return statusPaymentChannel( value ).text;
                    }
                },
                { field: "remark", label: "หมายเหตุ" }
            ]
            return columns
        },
        footerTotal(){
            let total = { credit: 0 }
            this.data.forEach( item => {total.credit += +item.credit} )
            return total
        }
    }
};
</script>